import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-person-point-detail',
  templateUrl: './person-point-detail.component.html',
  styleUrls: ['./person-point-detail.component.scss']
})
export class PersonPointDetailComponent implements OnInit {
  @Input() row;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    console.log(this.row);
  }


  getStatusText(status: number): string {
    switch (status) {
      /*  case 1:
          return 'Normal Çalışma';*/
      case 2:
        return 'Hafta İçi Mesaisi';
      case 3:
        return 'Hafta Sonu Mesaisi';
      case 4:
        return 'Uzaktan Mesai'
      case 5:
        return 'Telafi Mesaisi'
      case 6:
        return 'Destek Mesaisi'
      case 7:
        return 'Resmi Tatil Mesaisi'
      default:
        return 'Bilinmeyen Durum';
    }
  }

  getByDate(createdAt?: string, updateAt?: string) {
    const defaultValue = '0001-01-01T00:00:00';

    const validDate = updateAt !== defaultValue
      ? updateAt
      : createdAt !== defaultValue
        ? createdAt
        : null;

    return validDate
      ? new Date(validDate).toLocaleString('tr-TR')
      : '';
  }

  formatDate(date?: string) {
    const defaultValue = '0001-01-01T00:00:00';

    if (!date || date === defaultValue) return '';

    return new Date(date).toLocaleString('tr-TR');
  }

  getWorkDuration(start: string | Date, end: string | Date): string {
    if (!start || !end) return '-';

    const startDate = new Date(start);
    const endDate = new Date(end);

    const diffMs = endDate.getTime() - startDate.getTime();
    if (diffMs < 0) return '-';

    let totalMinutes = Math.floor(diffMs / (1000 * 60)); // fark dakikaya çevrildi
    const totalHours = totalMinutes / 60;

    // Kurallar: 4 <= süre < 7.5 saat ise 30dk, >= 7.5 saat ise 60dk düş
    if (totalHours > 4 && totalHours < 7.5) {
      totalMinutes -= 30;
    } else if (totalHours >= 7.5) {
      totalMinutes -= 60;
    }

    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;
    const minutesStr = finalMinutes.toString().padStart(2, '0');

    return `${finalHours}.${minutesStr}`;
  }

  closeModal() {
    this.activeModal.close();
  }
}
